import { Navigate, Route, Routes } from 'react-router'

import AppShell from './components/layout/AppShell'
import ProtectedRoute from './components/ProtectedRoute'
import ComingSoonPage from './pages/ComingSoonPage'
import DraftsPage from './pages/DraftsPage'
import HomePage from './pages/HomePage'
import LandingPage from './pages/LandingPage'
import LoginPage from './pages/LoginPage'
import MockupTemplatesPage from './pages/MockupTemplatesPage'
import NewWorkPage from './pages/NewWorkPage'
import PhotobookPage from './pages/PhotobookPage'
import PrivacyPage from './pages/PrivacyPage'
import QueuePage from './pages/QueuePage'
import SettingsPage from './pages/SettingsPage'
import WorkDetailPage from './pages/WorkDetailPage'
import WorksPage from './pages/WorksPage'

/**
 * Routes :
 * - `/`        — landing publique (vitrine en construction).
 * - `/privacy` — politique de confidentialite (publique, requise Pinterest API).
 * - `/atelier` — page de connexion (URL volontairement obscure pour reduire
 *   la surface de scan automatique ; ex-`/login`).
 * - tout le reste passe par <ProtectedRoute> + <AppShell> (sidebar + main).
 *   Les routes des sections futures (S3+) sont declarees ici au fur et a
 *   mesure ; en attendant, le catch-all `*` rend <ComingSoonPage> qui lit
 *   NAV_ITEMS pour annoncer le sprint d'activation.
 *
 * Catch-all global : tout chemin inconnu non authentifie retombe sur la
 * landing — pas sur `/atelier` — pour ne pas exposer l'URL de login aux bots.
 */
export default function App() {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/privacy" element={<PrivacyPage />} />
      {/* Alias avec le nom de l'entreprise dans l'URL — requis par la
          revue Pinterest API pour prouver que la politique appartient
          a SgraphiCCreations. Rend la meme page que /privacy. */}
      <Route path="/sgraphiccreations-privacy" element={<PrivacyPage />} />
      <Route path="/atelier" element={<LoginPage />} />
      <Route
        element={
          <ProtectedRoute>
            <AppShell />
          </ProtectedRoute>
        }
      >
        <Route path="/dashboard" element={<HomePage />} />
        <Route path="/works" element={<WorksPage />} />
        <Route path="/works/new" element={<NewWorkPage />} />
        <Route path="/works/:id/edit" element={<NewWorkPage />} />
        <Route path="/works/:id" element={<WorkDetailPage />} />
        <Route path="/mockups" element={<MockupTemplatesPage />} />
        <Route path="/drafts" element={<DraftsPage />} />
        <Route path="/queue" element={<QueuePage />} />
        <Route path="/photobook" element={<PhotobookPage />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="*" element={<ComingSoonPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}
